module.exports = __webpack_public_path__ + "img/instagram-solo.f7a0c289.svg";